import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const ventasStore = createCrudStore("ventas");

export default {
  ...ventasStore,
  state: {
    ...ventasStore.state,
    animalesEnPreparacion: [],
    historialVentas: [],
    estadisticas: null,
  },
  getters: {
    ...ventasStore.getters,
    animalesEnPreparacion(state) {
      return state.animalesEnPreparacion;
    },
    historialVentas(state) {
      return state.historialVentas;
    },
    estadisticas(state) {
      return state.estadisticas;
    },
  },
  mutations: {
    ...ventasStore.mutations,
    setAnimalesEnPreparacion(state, data) {
      state.animalesEnPreparacion = data;
    },
    setHistorialVentas(state, data) {
      state.historialVentas = data;
    },
    setEstadisticas(state, data) {
      state.estadisticas = data;
    },
  },
  actions: {
    ...ventasStore.actions,

    // Listar animales en preparación de venta
    async getAnimalesEnPreparacion({ commit, dispatch }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () => apiService.getCustom("ventas/preparacion"),
        onSuccessCallback: (commit, data) => {
          commit("setAnimalesEnPreparacion", data);
          console.log("Animales en preparación cargados:", data.length);
        },
        errorMessage: "Error al cargar animales en preparación",
      });
    },

    // Confirmar preparación de venta (paso 1)
    async confirmarPreparacion({ dispatch }, { animal_id, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(`ventas/preparar/${animal_id}`, payload || {}),
        onSuccessCallback: () => {
          console.log("Preparación de venta confirmada");
        },
        errorMessage: "Error al confirmar preparación de venta",
      });
    },

    // Actualizar datos de venta en preparación
    async actualizarVenta({ dispatch }, { venta_id, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(`ventas/${venta_id}`, payload),
        onSuccessCallback: () => {
          console.log("Venta actualizada correctamente");
        },
        errorMessage: "Error al actualizar datos de venta",
      });
    },

    // Confirmar venta final (paso 2)
    async confirmarVentaFinal({ dispatch }, { venta_id, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(`ventas/${venta_id}/confirmar`, payload),
        onSuccessCallback: () => {
          console.log("Venta confirmada exitosamente");
        },
        errorMessage: "Error al confirmar venta",
      });
    },

    // Confirmar venta en grupo (tropilla)
    async confirmarVentaGrupo({ dispatch }, payload) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(`ventas/grupo/confirmar`, payload),
        onSuccessCallback: () => {
          console.log("Venta en grupo confirmada exitosamente");
        },
        errorMessage: "Error al confirmar venta en grupo",
      });
    },

    // Cancelar preparación de venta
    async cancelarPreparacion({ dispatch }, venta_id) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.deleteCustom(`ventas/${venta_id}/cancelar`),
        onSuccessCallback: () => {
          console.log("Preparación cancelada");
        },
        errorMessage: "Error al cancelar preparación",
      });
    },

    // Obtener historial de ventas
    async getHistorialVentas({ commit, dispatch }, filtros = {}) {
      const params = new URLSearchParams();
      if (filtros.desde) params.append("desde", filtros.desde);
      if (filtros.hasta) params.append("hasta", filtros.hasta);
      if (filtros.categoria) params.append("categoria", filtros.categoria);

      const queryString = params.toString();
      const endpoint = queryString
        ? `ventas/historial?${queryString}`
        : "ventas/historial";

      return await dispatch("executeApiCall", {
        apiCallFunction: () => apiService.getCustom(endpoint),
        onSuccessCallback: (commit, data) => {
          commit("setHistorialVentas", data);
          console.log("Historial de ventas cargado:", data.length);
        },
        errorMessage: "Error al cargar historial de ventas",
      });
    },

    // Obtener estadísticas de ventas
    async getEstadisticasVentas({ commit, dispatch }, filtros = {}) {
      const params = new URLSearchParams();
      if (filtros.desde) params.append("desde", filtros.desde);
      if (filtros.hasta) params.append("hasta", filtros.hasta);

      const queryString = params.toString();
      const endpoint = queryString
        ? `ventas/estadisticas/resumen?${queryString}`
        : "ventas/estadisticas/resumen";

      return await dispatch("executeApiCall", {
        apiCallFunction: () => apiService.getCustom(endpoint),
        onSuccessCallback: (commit, data) => {
          commit("setEstadisticas", data);
          console.log("Estadísticas de ventas cargadas");
        },
        errorMessage: "Error al cargar estadísticas",
      });
    },

    // Obtener venta por ID
    async getVenta({ dispatch }, venta_id) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () => apiService.getCustom(`ventas/${venta_id}`),
        onSuccessCallback: (commit, data) => {
          console.log("Venta obtenida:", data);
        },
        errorMessage: "Error al obtener venta",
      });
    },

    // Actualizar venta
    async updateVenta({ dispatch }, { venta_id, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.putCustom(`ventas/${venta_id}`, payload),
        onSuccessCallback: () => {
          console.log("Venta actualizada con éxito");
          dispatch("getHistorialVentas");
        },
        errorMessage: "Error al actualizar la venta",
      });
    },
  },
};
